import { QuestionnaireSignatureInterface } from '../interfaces/questionnaire-signature.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('QuestionnaireSignatureModel')
export class QuestionnaireSignatureModel
  implements QuestionnaireSignatureInterface
{
  @JsonProperty('modelportfoliocode', String, true)
  modelportfoliocode: string = undefined;

  @JsonProperty('Exoneration', Boolean, true)
  exoneration: boolean = undefined;

  @JsonProperty('Signature', String, true)
  signature: string = undefined;
}
